// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TableViewIcon from "@mui/icons-material/TableView";
import LeadCreateInner from "./LeadCreateInner";


class LeadCreateModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Добавление лида',
            modalIcon: TableViewIcon,
            mainComponent: LeadCreateInner,
            mainComponentProps: {
                callBack: this.callBack.bind(this),
            },
        }
    }

    async callBack() {
        if (typeof this.props.callBack == 'function') {
            await this.props.callBack();
        }
        this.setModalOpenFalse();
    }
}

export default LeadCreateModal
